import { useContext } from "react";

import { Heading, Stack, Box } from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";

import { RegionType } from "@/codegen/openapi2";
import { TableLayout } from "@/components/2/layouts/table";
import { LegalEntityName } from "@/components/2/legal-entity";
import { LegalEntityContext } from "@/components/2/legal-entity-context";
import { useGetRegionsGeographiesRegionsGet } from "@/services/2/react-query/hooks";

const columnHelper = createColumnHelper<RegionType>();

const columns = [
  columnHelper.accessor("legal_entity_uuid", {
    header: "Entité",
    cell: ({ cell }) => <LegalEntityName legalEntityUuid={cell.getValue()} />,
    minSize: 150,
  }),
  columnHelper.accessor("name", { header: "Nom" }),
];

export const Regions = () => {
  const legalEntityContext = useContext(LegalEntityContext);

  const { data } = useGetRegionsGeographiesRegionsGet(
    { query: { legal_entity_uuids: legalEntityContext ? [legalEntityContext] : null } },
    ["uncached", legalEntityContext || "all"],
    { placeholderData: [] }
  );

  return (
    <Stack>
      <Box p={8} backgroundColor={"gray.100"}>
        <Heading size="2xl">Regions</Heading>
      </Box>

      <Box p={8}>
        <TableLayout data={data as RegionType[]} columns={columns} />
      </Box>
    </Stack>
  );
};
